import React from 'react'

const MediaItem = ({ mediaItem }) => (
  <div className="pt-5">
    {mediaItem.image[0]?.url && (
      <img
        src={mediaItem.image[0].url}
        alt=""
        className="w-full h-auto shadow-tpmp lg:shadow-dp rounded-[5px]"
      />
    )}
    {mediaItem.youtubeId && (
      <iframe
        title="YouTube"
        src={`https://www.youtube.com/embed/${mediaItem.youtubeId}?modestbranding=1&rel=0`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="w-full aspect-video rounded-[5px] shadow-tpmp lg:shadow-dp"
      ></iframe>
    )}
  </div>
)

export default MediaItem
